import { MagnifyingGlass, Siren } from '@phosphor-icons/react'
import React, { useState } from 'react'
import { Button } from '../../components/common/Button'
import { DefaultContent } from '../../components/common/DefaultContent'
import { Input } from '../../components/common/Input'
import {
  ButtonContainer,
  CamerasBox,
  Container,
  FilterBox,
  InputContainer,
  Row,
  Title,
} from './styles'

import { Helmet } from 'react-helmet'

export const SecurityCamera = () => {
  const [buttonSearchActived, setButtonSearchActived] = useState(false)
  const [search, setSearch] = useState('')
  const handleSearchChange = (e) => {
    setSearch(e.target.value)
  }

  const handleState = (setValue) => {
    setValue((prev) => !prev)
  }

  return (
    <>
      <Helmet>
        <title>Previx - Câmeras</title>
        <meta name="Previx - Câmeras" content="Câmeras de segurança" />
      </Helmet>
      <DefaultContent
        icon={<Siren size={26} color="#003E5F" />}
        title="Previx - Vigilância - Câmera de segurança"
      >
        <Container>
          <FilterBox>
            <Title>Filtros para localizar câmera</Title>
            <Row>
              <InputContainer>
                <Input.Root>
                  <Input.Wrapper
                    borderColor="#CECECE"
                    backgroundColor="#F7F7F7"
                    outlineColor=""
                  >
                    <Input.Content
                      id="securityCameraSearch"
                      onChange={handleSearchChange}
                      type="text"
                      value={search}
                      placeholder="Digite para pesquisar"
                    />
                    <Input.Icon>
                      <MagnifyingGlass size={16} color="#494949" />
                    </Input.Icon>
                  </Input.Wrapper>
                </Input.Root>
              </InputContainer>
              <ButtonContainer>
                <Button.Root
                  onClick={() => handleState(setButtonSearchActived)}
                  backgroundColor="#150D49"
                  type="button"
                >
                  <Button.Content title="Buscar" color="#fff" />
                </Button.Root>
              </ButtonContainer>
            </Row>
          </FilterBox>
          {buttonSearchActived ? (
            <CamerasBox>
              <Title>Câmeras - “XXXXXXXXXXXXXXXXXXXXXXXXX”</Title>
            </CamerasBox>
          ) : null}
        </Container>
      </DefaultContent>
    </>
  )
}
